import { Grid, Button, Divider } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import Modal from 'react-modal';
import CloseIcon from '@material-ui/icons/Close';
import React, { useEffect, useState } from 'react';
import Theme from '../ui/Theme';
import InstructorAssignCardDaily from './InstructorAssignCardDaily';

const useStyles = makeStyles(() => ({
  frameStyle: {
    width: '500px',
    height: '45px',
  },
  contentStyle: {
    width: '500px',
    height: '349px',
    marginLeft: 'calc(50% - 500px/2)',
    marginTop: '20px',
  },
  titleFrame: {
    width: '283px',
    height: '45px',
  },
  searchFrame: {
    width: '270px',
    height: '49px',
    background: Theme.palette.secondary.main,
    marginLeft: '2%',
  },

  closeIcon: {
    width: '26px',
    height: '26px',
    borderRadius: '50%',
    backgroundColor: Theme.palette.secondary.main,
    padding: '8px',
    '&:hover': {
      backgroundColor: 'rgba(0, 0, 0, 0.4)',
    },
  },
  filterIcon: {
    width: '73px',
    height: '49px',
    backgroundColor: '#FAFAFA',
    cursor: 'pointer',
    padding: '8px',
    '&:hover': {
      backgroundColor: 'FAFAFA',
    },
  },
  titleText: {
    fontFamily: 'Montserrat',
    fontStyle: 'normal',
    fontWeight: '600',
    fontSize: '18px',
    lineHeight: '22px',
    color: '#000000',
  },

  searchText: {
    fontFamily: 'Montserrat',
    fontStyle: 'normal',
    fontWeight: '500',
    fontSize: '14px',
    lineHeight: '0px',
    color: 'black',
  },
  mainContent: {
    background: Theme.palette.secondary.main,
    alignItems: 'center',
  },
  buttonGroup: {
    marginLeft: '14%',
  },
  cancelButton: {
    width: '111px',
    height: '42px',
    fontFamily: 'Montserrat',
    fontStyle: 'normal',
    fontWeight: '600',
    fontSize: '14px',
    lineHeight: '17px',
    textAlign: 'center',
  },
  submitButton: {
    width: '216px',
    height: '42px',
    marginLeft: '20px',
    fontFamily: 'Montserrat',
    fontStyle: 'normal',
    fontWeight: '600',
    fontSize: '14px',
    lineHeight: '17px',
    textAlign: 'center',
  },
  titleSubText: {
    fontFamily: 'Montserrat',
    fontStyle: 'normal',
    fontWeight: '500',
    fontSize: '12px',
    lineHeight: '15px',
    marginTop: '8px',
    color: 'rgba(0, 0, 0, 0.4)',
  },
}));
const AssignInstructorDaily = ({
  open,
  close,
  handleAssignInstr,
  instrlist,
  doseType,
  checkedInstrList,
  setCheckedInstrList,
}) => {
  const classes = useStyles();

  const [viewAssign, setViewAssign] = useState(open);
  const [filterArray, setFilterArray] = useState([]);
  const handleClosePopup = () => {
    setViewAssign(false);
    close();
  };
  useEffect(() => {
    setFilterArray(instrlist);
  }, [instrlist]);

  const submit = () => {
    handleAssignInstr();
    close();
  };

  return (
    <div>
      <Modal
        onRequestClose={() => false}
        shouldCloseOnEsc={false}
        isOpen={viewAssign}
        style={{
          overlay: {
            backgroundColor: 'hsla(50, 33%, 25%, 0.35)',
          },
          content: {
            padding: '20px 16px 28px',
            width: '500px',
            height: '502px',
            background: '#FFFFFF',
            left: '50%',
            top: '50%',
            transform: 'translate(-50%, -50%)',
            overflow: 'hidden',
          },
        }}
      >
        <Grid container direction="column">
          <Grid item className={classes.frameStyle}>
            <Grid container direction="row" justifyContent="space-between">
              <Grid item className={classes.titleFrame}>
                <Grid container direction="column">
                  <Grid item className={classes.titleText}>
                    Assign Instructors
                  </Grid>
                  <Grid item className={classes.titleSubText}>
                    To Story
                  </Grid>
                </Grid>
              </Grid>
              <Grid item onClick={handleClosePopup}>
                <CloseIcon className={classes.closeIcon} />
              </Grid>
            </Grid>
          </Grid>
          <Grid item className={classes.contentStyle}>
            <InstructorAssignCardDaily
              instrlist={filterArray}
              doseType={doseType}
              checkedInstrList={checkedInstrList}
              setCheckedInstrList={setCheckedInstrList}
            />
          </Grid>
          <Divider
            style={{
              width: '500px',
              marginTop: '30px',
              marginBottom: '24px',
              marginLeft: '16px',
            }}
          />
          <Grid item>
            <Grid container direction="row" className={classes.buttonGroup}>
              <Grid item>
                <Button variant="contained" onClick={close} disableElevation className={classes.cancelButton}>
                  Cancel
                </Button>
              </Grid>
              <Grid item>
                <Button variant="contained" color="primary" className={classes.submitButton} onClick={submit}>
                  Assign Instructor
                </Button>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Modal>
    </div>
  );
};
export default AssignInstructorDaily;
